import { useContext } from "react";
import { AuthContext } from "../context/authProvider/AuthProvider";

const useAuth = () => {
  return useContext(AuthContext);
};
export default useAuth;
